import Vue from 'vue'
import request from '@/helpers/request'
import router from '@/router'
import snack from '@/helpers/snack'

export default {
  GET_INVENTS: ({ commit, state }, payload) => {
    commit('setInvents', [])

    return new Promise((resolve, reject) => {
      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.all}`,
        {
          params: payload.params,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('updateInvents', data.items)
          commit('setInventFilters', data.filters)
          commit('setLoad', false)
          resolve(data.count)
        }
      })
    })
  },
  GET_INVENT_STATUSES: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.status}`, {}, true).then(
        response => {
          if (response.data.result === 'success') {
            const data = response.data.data
            commit('setInventStatuses', data)
          } else {
          }

          resolve()
        },
      )
    })
  },
  GET_INVENT: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'unit;store;employer;items;items.good',
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setInvent', item)
          // commit('setTitle', state.invent.id);
          commit('setLoad', false)
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        resolve()
      })
    })
  },
  CREATE_INVENT: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.all}`,
        {
          company_id: state.invent.company_id,
          unit_id: state.invent.unit_id,
          store_id: state.invent.store_id,
          employer_id: state.invent.employer_id,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data
          commit('setInventField', { id: data.data.id })
          commit('prependInvents', state.invent)

          router.push({ path: Vue.config.modules.crm.route.goodInvents.one.replace('$1', data.data.id) })
          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  UPDATE_INVENT: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.one.replace('$1', state.invent.id)}`,
        {
          company_id: state.invent.company_id,
          unit_id: state.invent.unit_id,
          store_id: state.invent.store_id,
          employer_id: state.invent.employer_id,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('changeInvent', state.invent)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_INVENT: ({ commit, state, dispatch }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.one.replace('$1', state.invent.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('deleteInvent', state.invent.id)

          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        const item = _.first(state.invents)

        if (item) {
          dispatch('GET_INVENT', {
            item: item.id,
          }).then(() => {
            router.push({ path: Vue.config.modules.crm.route.goodInvents.one.replace('$1', item.id) })
            resolve()
          })
        } else {
          router.push({ path: Vue.config.modules.crm.route.goodInvents.all })
          resolve()
        }

        commit('setLoad', false)
      })
    })
  },
  PROCESS_INVENT: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.process.replace('$1', state.invent.id)}`,
        {
          with: 'unit;store;employer;items.good',
          attr: {
            company_id: state.invent.company_id,
            unit_id: state.invent.unit_id,
            store_id: state.invent.store_id,
            employer_id: state.invent.employer_id,
          },
        },
        true,
      )
        .then(response => {
          if (response.data.result === 'success') {
            const item = response.data.data
            commit('setInvent', item)
            commit('changeInvent', state.invent)

            snack.add(Vue.config.localization.ru.savedMessage, 'primary')
          } else {
            snack.add(Vue.config.localization.ru.notFoundMessage)
          }
        })
        .finally(() => {
          commit('setLoad', false)
        })

      resolve()
    })
  },
  RECOUNT_INVENT_REMAINS: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.recount.replace('$1', state.invent.id)}`,
        {
          with: 'store;employer;items.good',
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setInvent', item)

          snack.add(Vue.config.localization.ru.refreshedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  ADD_GOODS_TO_INVENT: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInvents.add.replace('$1', state.invent.id)}`,
        {
          with: 'unit;store;employer;items.good',
          attr: {
            company_id: state.invent.company_id,
            unit_id: state.invent.unit_id,
            store_id: state.invent.store_id,
            employer_id: state.invent.employer_id,
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const item = response.data.data
          commit('setInvent', item)
          commit('changeInvent', state.invent)

          snack.add(Vue.config.localization.ru.savedMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  CREATE_INVENT_ITEM: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'POST',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInventItems.all}`,
        {
          with: 'good',
          attr: payload,
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('addInventItem', data)

          const msg = Vue.config.localization.ru.goodInventGoodAdded
            .replace('$1', data.good.title)
            .replace('$2', data.qty)
          snack.add(msg, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  UPDATE_INVENT_ITEM: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInventItems.one.replace('$1', payload.id)}`,
        {
          with: 'good',
          attr: {
            qty: payload.qty,
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          commit('changeInventItem', data)

          const msg = Vue.config.localization.ru.goodInventGoodUpdated
            .replace('$1', data.good.title)
            .replace('$2', data.qty)
          snack.add(msg, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },
  DELETE_INVENT_ITEM: ({ commit, state, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInventItems.one.replace('$1', payload.id)}`,
        {},
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          commit('deleteInventItem', payload.id)

          snack.add(Vue.config.localization.ru.deleteMessage, 'primary')
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage)
        }

        resolve()
      })
    })
  },
  UPDATE_INVENT_ITEM_BY_BARCODE: ({ commit, state }, payload) => {
    return new Promise((resolve, reject) => {
      commit('setLoad', true)

      request(
        'PUT',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodInventItems.barcode.replace('$1', payload.barcode)}`,
        {
          with: 'good',
          attr: {
            good_invent_id: payload.good_invent_id,
            qty: payload.qty,
          },
        },
        true,
      ).then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data

          if (data) {
            commit('addInventItem', data)
            const msg = Vue.config.localization.ru.goodInventGoodAdded
              .replace('$1', data.good.title)
              .replace('$2', data.qty)
            snack.add(msg, 'primary')
          } else {
            if (data === false) {
              snack.add(Vue.config.localization.ru.goodBarcodeFound.replace('$1', payload.barcode), 'error')
            } else {
              snack.add(Vue.config.localization.ru.goodFlowBarcodeNotFound.replace('$1', payload.barcode), 'error')
            }
          }
        } else {
          snack.add(Vue.config.localization.ru.notFoundMessage, 'error')
        }
      })

      commit('setLoad', false)
      resolve()
    })
  },

  async GET_INVENT_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_INVENT_STATUSES'),
      dispatch('GET_UNITS', { params: { filter: 'id;name' } }),
      dispatch('GET_STORES', { params: { filter: 'id;title' } }),
    ])
    commit('setLoad', false)
  },

  async GET_INVENT_NEW_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_INVENT_STATUSES'),
      dispatch('GET_INVENTS', payload),
      dispatch('GET_UNITS', { params: { filter: 'id;name' } }),
      dispatch('GET_STORES', { params: { filter: 'id;title' } }),
      dispatch('GET_FLOW_QTY_UNITS'),
    ])
    commit('setLoad', false)
  },

  async GET_INVENT_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([
      dispatch('GET_INVENT', payload),
      dispatch('GET_INVENT_STATUSES'),
      dispatch('GET_INVENTS', payload),
      dispatch('GET_UNITS', { params: { filter: 'id;name' } }),
      dispatch('GET_STORES', { params: { filter: 'id;title' } }),
      dispatch('GET_FLOW_QTY_UNITS'),
    ])
    commit('setLoad', false)
  },
}
